// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vv_a bhb_b bhb_ux"};